import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBeetle = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 17 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.4153 7.97654H8.40662M13.4153 7.97654L12.6733 13.1378M13.4153 7.97654L12.8588 5.16129M8.40662 15.4839V7.97654M8.40662 15.4839L3.95444 13.1378M8.40662 15.4839L12.6733 13.1378M3.39792 7.97654H8.40662M3.39792 7.97654L3.95444 13.1378M3.39792 7.97654L3.95444 5.16129M3.95444 13.1378L2.00662 14.4516V16M12.6733 13.1378L14.8066 14.4516V16M4.51096 2.34604L8.40662 0.938415L12.3023 2.34604M4.51096 2.34604L2.00662 1.64223V-7.15256e-07M4.51096 2.34604L3.95444 5.16129M12.3023 2.34604L14.8066 1.64223V-7.15256e-07M12.3023 2.34604L12.8588 5.16129M12.8588 5.16129H14.8066L16.4066 6.19355M3.95444 5.16129H2.00662L0.406616 6.19355",
		stroke: "black",
		strokeWidth: 1.5,
		strokeLinejoin: "bevel"
	})
});
export default SvgBeetle;
